import React, { FC, PropsWithChildren } from 'react'
import Modal from 'react-modal'
import { ModalContent, ModalFooter, ModalFooterButton, ModalHeader, modalStyle } from './styles'
import classNames from 'classnames'

type Props = PropsWithChildren<{
  onClose?(): void
  retry?(): void
}>

// Render this instead of SettingsPopup when contents are not ready
export const SettingsPopupWithError: FC<Props> = ({ onClose, retry, children }) => {
  return (
    <Modal
      isOpen={true}
      style={modalStyle}
      onRequestClose={onClose}
      className={classNames('e2e-botsettings-modal modal-default')}
    >
      <ModalHeader></ModalHeader>
      <ModalContent>{children || 'There was an error trying to load this popup'}</ModalContent>
      <ModalFooter>
        <ModalFooterButton
          label="Try again"
          className="e2e-close-bot-modal-button"
          onClick={retry}
        />
        <ModalFooterButton label="Close" className="e2e-close-bot-modal-button" onClick={onClose} />
      </ModalFooter>
    </Modal>
  )
}

export type SettingsPopupWithLoaderProps = Props
